import { Link } from 'react-router-dom';
import { useRankingAd } from '@/hooks/api/useRankingAd';
import { Helmet } from 'react-helmet-async';
import Axios, { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import * as _m from '@/models';

export const RankingAd = () => {
  // const { data: ranking_ad } = useRankingAd();

  const [rankingAd, setRankingAd] = useState<_m.RankingAd>();
  useEffect(() => {
    Axios.get(`${process.env.REACT_APP_AD_URL}/embed_ad.json`).then((res: AxiosResponse<_m.RankingAd>) => {
      setRankingAd(res.data);
    });
  }, []);

  // if (!ranking_ad) {
  //   return null;
  // }

  if (!rankingAd) {
    return null;
  }

  return (
    <main>
      <Helmet>
        <title>広告バナー | ヘブンTV</title>
      </Helmet>

      <Link
        className="embedded-banner-wrapper"
        target="_blank"
        to={`${rankingAd.url}?banner=001`}
        rel="noopener noreferrer"
      >
        <img src={`${rankingAd.cover_image_url}`} alt={``} />
      </Link>
    </main>
  );
};
